var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeoFencesColor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 10.8333C11.3807 10.8333 12.5 9.71403 12.5 8.33332C12.5 6.95261 11.3807 5.83332 9.99998 5.83332C8.61927 5.83332 7.49998 6.95261 7.49998 8.33332C7.49998 9.71403 8.61927 10.8333 9.99998 10.8333Z",
    stroke: "#FAFEFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 18.3333C13.3333 15 16.6666 12.0152 16.6666 8.33332C16.6666 4.65142 13.6819 1.66666 9.99998 1.66666C6.31808 1.66666 3.33331 4.65142 3.33331 8.33332C3.33331 12.0152 6.66665 15 9.99998 18.3333Z",
    stroke: "#FAFEFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeoFencesColor);
export default __webpack_public_path__ + "static/media/Geo_Fences_Color.0e66cd0690e83c8b115d27444ca1b71b.svg";
export { ForwardRef as ReactComponent };